import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../layout/layout.component';
import { PagerService } from '../../common/pagerService';
import 'rxjs/add/operator/map';
import { SampStatSearchFields } from '../../common/viewModels/Reports/SampleStatisticsModel';
import { CustomerModel } from '../../common/viewModels/Admin/CustomerModel';
import { FormatService } from '../../common/formatService';

@Component({
    selector: 'samplestatistics',
    templateUrl: './samplestatistics.component.html',
    styleUrls: ['./samplestatistics.component.scss']
})
export class SampleStatistics implements OnInit {
    searchForm: FormGroup;
    searchFields: SampStatSearchFields = new SampStatSearchFields();
    id: number;
    isNoRecords: boolean = true;
    pager: any = {};
    pagedItems: any[];
    length: number = 0;
    pageIndex: number = 0;
    pageSizeOptions = [10, 25];
    name: any;
    customers: CustomerModel[];
    labs: any;
    pageSize: number = 10;
    isShowSelectOption: boolean = true;


    constructor(private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _pagerService: PagerService,
        private _mApp: MainAppComponent, private _toastrService: ToastrService,
        private _formatService: FormatService) {
    }

    ngOnInit() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
        this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
        this.pager.pageSize = this.pageSize;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
        this.createSearchForm();
        if (curUserDetails && curUserDetails.LabIds && curUserDetails.UserTypeId == 2) {
            this.searchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
        }
        if (curUserDetails && curUserDetails.DefaultCompanyId) {
            this.searchForm.controls['CustomerId'].setValue(parseInt(curUserDetails.DefaultCompanyId));
        }
        if(curUserDetails && curUserDetails.RoleId == 9 && curUserDetails.UserTypeId == 3){
            this.isShowSelectOption = false;
        }
        this.GetCustomers();
        this.GetLabs();
        this.BindStaticSearchData();
        this.setPage(this.pager);
    }

    createSearchForm() {
        this.searchForm = this._formBuilder.group({
            CustomerId: [''],
            LabIds: [''],
            ReceivedFrom: [null],
            ReceivedTo: [null],
            LabName: [''],
        });
    }

    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        this.GetSampleStatics(this.pager);
    }

    BindStaticSearchData() {
        this.searchFields.PageNo = 0;
        this.searchFields.PageSize = this._pagerService.globalPageSize;
    }

    GetCustomers() {
        this._http.get(this._appUrl.GetCustomersMinInfoList)
            .subscribe(
                data => {
                    this.customers = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    GetLabs() {
        this._http.get(this._appUrl.GetLabsMinInfoList)
            .subscribe(
                data => {
                     if(this._mApp.userTypeId == 2) {
                        let lstLabs = data.json().Result;
                        if (this._mApp.currentUserLabIds && lstLabs)
                        lstLabs = lstLabs.filter(m => this._mApp.currentUserLabIds.includes(m.LabId));
                        this.labs = lstLabs;
                    }
                    else {
                        this.labs = data.json().Result;
                    }
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    GetSampleStatics(page: any) {
        this._mApp.ShowLoader();
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize
        this._mApp.ShowLoader();
        this._http.post(this._appUrl.GetSampleStatisticsList, this.searchFields)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    var data = res.json();
                    this.length = data.PageResult.TotalRecords;
                    this.pageSize = data.PageResult.PageSize;
                    this.pageIndex = data.PageResult.PageNo;
                    this.pagedItems = data.Result;
                    this.isNoRecords = !(data.Result.length > 0);
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    ExportSampStatExcel() {
        this._mApp.ShowLoader();
        this.onSubmit();
        this.searchFields.IsForExcel = true;
        this._http.post(this._appUrl.ExportSampStatExcel, this.searchFields)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    window.open(res.json().Result, '_blank');
                    this.searchFields.IsForExcel = false;
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    onSubmit() {
        this.pager.pageIndex = 0;
        let searchDto = this.searchForm.value;
        this.searchFields.CustomerId = searchDto.CustomerId;
        this.searchFields.LabIds = searchDto.LabIds;
        this.searchFields.ReceivedFrom = this._formatService.formatDate(searchDto.ReceivedFrom);
        this.searchFields.ReceivedTo = this._formatService.formatDate(searchDto.ReceivedTo);
        this.searchFields.LabName = searchDto.LabName;
        this.setPage(this.pager);
    }

    OnReset() {
        this.searchForm.reset();
        this.searchFields.CustomerId = this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0;
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        this.searchFields.ReceivedFrom = '';
        this.searchFields.ReceivedTo = '';
        this.searchFields.LabName = '';
        this.searchFields.LabIds = [];
        this.searchForm.controls['CustomerId'].setValue(this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0);
        this.GetCustomers();
        this.setPage(this.pager);
        if (this._mApp.userTypeId == 2) {
            var currentUser = JSON.parse(localStorage.getItem('currentUser'));
            let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
            this.searchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
        }
    }

    DeleteSample(id: any) {
        this.id = id;
    }

    DeleteSampleById(id: number) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DeleteSample + id)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    this.setPage(this.pager);
                    this._toastrService.success(res.json().Result, '');
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

}
